export default "__VITE_ASSET__DdtGhqbX__"